import { render, staticRenderFns } from "./InvestmentsSettingsEditModal.vue?vue&type=template&id=36682775&"
import script from "./InvestmentsSettingsEditModal.vue?vue&type=script&lang=js&"
export * from "./InvestmentsSettingsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports